
<div class="nav-bar"
     [class.is-slideshow-active]="slideshowActive"
     style="--top-toolbar-height: calc((40px * var(--dvm-font-scale, 1)) + 16px); height: var(--dvh, 100vh); min-height: var(--dvh, 100vh); overflow: hidden;">

  <!-- TOP TOOLBAR -->
      <mat-toolbar
      class="d-flex justify-content-between align-items-center px-3 custom-toolbar-shadow"
      style="position: fixed; top: 0; left: 0; right: 0; z-index: 1001; padding: 0.5rem; height: var(--top-toolbar-height); min-height: var(--top-toolbar-height); box-sizing: border-box; background-color: var(--dvm-toolbar-bg, #9ccafb); color: var(--dvm-toolbar-text, rgb(37, 32, 97));">

      <div class="d-flex align-items-center">
        <button mat-icon-button class="mobile-menu-toggle me-2" *ngIf="isMobileLayout" (click)="toggleSidebar()"
          style="color: var(--dvm-toolbar-text, rgb(37, 32, 97));" aria-label="Toggle navigation menu">
          <mat-icon>menu</mat-icon>
        </button>

      <!-- Use Case 2a: Client logo image provided → show image alone -->
      <img *ngIf="hasClientLogo && clientLogo"
           [src]="clientLogo"
           alt="Client Logo"
           class="primary-logo"
           style="margin-right: 6px;">

      <!-- Use Case 2b: Client icon + text provided → show mat-icon + text -->
      <ng-container *ngIf="hasClientLogo && !clientLogo && clientIcon">
        <span class="client-icon-wrap">
          <mat-icon class="client-icon">{{ clientIcon }}</mat-icon>
        </span>
        <span class="fw-bold fs-5 company-text">{{ clientText }}</span>
      </ng-container>

      <!-- Use Case 1: No client logo → show SIM Advisory default branding (logo + company text) -->
        <ng-container *ngIf="!hasClientLogo">
          <img [src]="logo" alt="Logo"
               class="primary-logo"
               [style.height.px]="useAltSidenav ? 30 : null"
               [style.width.px]="useAltSidenav ? 40 : null"
               style="margin-right: 6px;">
          <span class="fw-bold fs-5 company-text">{{ companyText }}</span>
        </ng-container>

      <span *ngIf="dashboardTitlePosition === 'top' && dashboardTitle"
            class="dashboard-title-inline"
            [style.font-size]="dashboardTitleFontSize || null">
        {{ dashboardTitle }}
      </span>
      </div>


    <div class="d-flex align-items-center top-toolbar-right"
         style="gap: 12px;">
      <!-- <img *ngIf="!useAltSidenav" [src]="secondaryLogo" alt="Secondary Logo"
           class="secondary-logo"> -->
      <div style="font-weight: 500; color: var(--dvm-toolbar-text, inherit);">Welcome {{ username }}</div>

      <button *ngIf="showThemeOptions"
              mat-icon-button (click)="openThemeSelector()"
              matTooltip="Theme Options" matTooltipPosition="below"
              matTooltipClass="dvm-theme-tooltip"
              aria-label="Theme Options"
              style="color: var(--dvm-toolbar-text, rgb(37, 32, 97));">
        <mat-icon>palette</mat-icon>
      </button>

      <!-- Save Theme — only visible when a previewed theme is pending save. -->
      <button *ngIf="showThemeOptions && hasPendingThemePreview"
              mat-stroked-button
              (click)="saveThemePreview()"
              matTooltip="Save the previewed theme"
              matTooltipPosition="below"
              aria-label="Save Theme"
              class="save-theme-btn"
              style="color: var(--dvm-toolbar-text, rgb(37, 32, 97)); border-color: var(--dvm-toolbar-text, rgba(0,0,0,0.4));">
        <mat-icon style="margin-right: 4px;">save</mat-icon>
        <span>Save Theme</span>
      </button>

      <!-- Light/Dark theme toggle -->
      <button *ngIf="showThemeToggle"
              mat-icon-button
              (click)="toggleTheme()"
              [matTooltip]="isDarkTheme ? 'Switch to light theme' : 'Switch to dark theme'"
              matTooltipClass="theme-toggle-tooltip"
              [attr.aria-label]="isDarkTheme ? 'Switch to light theme' : 'Switch to dark theme'"
              style="color: var(--dvm-toolbar-text, rgb(37, 32, 97));">
        <mat-icon>{{ isDarkTheme ? 'light_mode' : 'dark_mode' }}</mat-icon>
      </button>

      <button mat-icon-button (click)="logout()" title="Logout"
              style="color: var(--dvm-toolbar-text, rgb(37, 32, 97));">
        <mat-icon>logout</mat-icon>
      </button>
    </div>
  </mat-toolbar>

  <!-- Slideshow strip — fixed-positioned banner that sits directly below the
       top nav while a slideshow is running. Started from the Theme Options
       dialog's Slideshow tab; the dialog closes on Play so the user steers
       the cycling themes from this strip. Combines:
         · live theme name + counter on the left
         · transport controls (prev / play / next) in the centre cluster
         · Apply / Save / Stop on the right
         · the progress bar pinned to the strip's bottom edge
       Renders on a card-coloured surface so it stays clearly distinct from
       the toolbar above on every theme. -->
  <div *ngIf="slideshowActive"
       class="slideshow-strip"
       [style.top]="'var(--top-toolbar-height)'">
    <div class="slideshow-strip-inner">
      <!-- Meta: theme being previewed + position in queue. -->
      <div class="slideshow-strip-meta">
        <mat-icon class="slideshow-strip-icon">slideshow</mat-icon>
        <span class="slideshow-strip-label">Previewing</span>
        <span class="slideshow-strip-name" *ngIf="slideshowCurrentName">
          {{ slideshowCurrentName }}
        </span>
        <span class="slideshow-strip-counter" *ngIf="slideshowTotal">
          {{ slideshowIndex + 1 }} / {{ slideshowTotal }}
        </span>
      </div>

      <!-- Transport: prev / play-pause / next. -->
      <div class="slideshow-strip-transport">
        <button mat-icon-button class="slideshow-btn"
                (click)="slideshowPrev()"
                matTooltip="Previous theme"
                matTooltipPosition="below"
                aria-label="Previous theme">
          <mat-icon>skip_previous</mat-icon>
        </button>
        <button mat-icon-button class="slideshow-btn is-play"
                (click)="toggleSlideshowPlayback()"
                [matTooltip]="slideshowPlaying ? 'Pause' : 'Play'"
                matTooltipPosition="below"
                [attr.aria-label]="slideshowPlaying ? 'Pause slideshow' : 'Play slideshow'">
          <mat-icon>{{ slideshowPlaying ? 'pause' : 'play_arrow' }}</mat-icon>
        </button>
        <button mat-icon-button class="slideshow-btn"
                (click)="slideshowNext()"
                matTooltip="Next theme"
                matTooltipPosition="below"
                aria-label="Next theme">
          <mat-icon>skip_next</mat-icon>
        </button>
      </div>

      <!-- Actions: Apply (preview-and-keep), Save (commit), Stop (cancel). -->
      <div class="slideshow-strip-actions">
        <button mat-flat-button class="slideshow-action is-apply"
                (click)="slideshowApply()"
                aria-label="Apply current theme">
          Apply
        </button>
        <button mat-flat-button class="slideshow-action is-save"
                (click)="slideshowSave()"
                aria-label="Save current theme">
          <mat-icon>save</mat-icon>
          <span>Save</span>
        </button>
        <button mat-icon-button class="slideshow-btn is-stop"
                (click)="slideshowStop()"
                matTooltip="Stop slideshow"
                matTooltipPosition="below"
                aria-label="Stop slideshow">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>

    <!-- Progress bar pinned to the strip's bottom edge — fills 0%→100% over
         each slide cycle and resets on advance. Inside the strip so it
         visually belongs to the slideshow, not the top nav. -->
    <div class="slideshow-progress-bar"
         role="progressbar"
         [attr.aria-valuenow]="(slideshowProgress * 100) | number:'1.0-0'"
         aria-valuemin="0"
         aria-valuemax="100"
         aria-label="Slideshow progress">
      <div class="slideshow-progress-fill"
           [style.width.%]="slideshowProgress * 100"
           [class.paused]="!slideshowPlaying"></div>
    </div>
  </div>

  <!-- MAIN LAYOUT -->
  <mat-sidenav-container class="flex-1 h-full" [autosize]="true">

    <!-- SIDENAV -->
                    <mat-sidenav
                      [mode]="isMobileLayout ? 'over' : 'side'"
                      [opened]="isMobileLayout ? isMobileDrawerOpen : true"
                      class="sidenav transition-all duration-300 ease-in-out"
                      [class.is-resizing]="isResizingSidebar"
                      [style.overflow]="'hidden'"
                      style="top: calc(var(--top-toolbar-height) + var(--slideshow-strip-h, 0px));
                        height: calc(var(--dvh, 100vh) - var(--top-toolbar-height) - var(--slideshow-strip-h, 0px));
                        box-shadow: 4px 0 10px rgba(1,12,60,0.2);
                        z-index: 1000;
                        background-color: var(--dvm-sidebar-bg, #97c6f9);
                        color: var(--dvm-sidebar-text, #000);"
                      [style.width]="isMobileLayout ? '84vw' : (isCollapsed ? '72px' : sidebarExpandedWidth + 'px')"
                      [style.transition]="isResizingSidebar ? 'none' : null">

      <div class="flex items-center justify-between px-3" style="padding-top: 24px; padding-bottom: 8px;">
        <button mat-icon-button (click)="toggleSidebar()"
          style="color: var(--dvm-sidebar-text, rgb(18,17,17));">
          <mat-icon>menu</mat-icon>
        </button>
      </div>

      <!-- MENU -->
      <mat-nav-list>
        <ng-container *ngFor="let item of menuItems">

          <!-- NO CHILD -->
          <a mat-list-item
             *ngIf="!hasChildren(item)"
             class="menuItems flex items-center px-4"
             [routerLink]="item.path"
             [ngClass]="{'active-item': isActive(item)}"
             [ngClass]="{'justify-center': isCollapsed}"
             [matTooltip]="item.name"
             matTooltipPosition="right">

            <mat-icon style="color: var(--dvm-sidebar-text, black);" class="pt-2">
              {{ item.icon }}
            </mat-icon>

            <span style="padding-left:20px; font-weight:500; color: var(--dvm-sidebar-text, black);"
                  [ngClass]="{'hidden': isCollapsed}">
              {{ item.name }}
            </span>
          </a>

          <!-- WITH CHILD -->
          <ng-container *ngIf="hasChildren(item)">
            <a mat-list-item
               class="menuItems flex items-center px-4"
               (click)="toggleSubmenu(item.name, $event)"
               [ngClass]="{'justify-center': isCollapsed}"
               [matTooltip]="item.name"
               matTooltipPosition="right">

              <mat-icon style="color: var(--dvm-sidebar-text, black);" class="pt-2">
                {{ item.icon }}
              </mat-icon>

              <span style="padding-left:20px; font-weight:500; color: var(--dvm-sidebar-text, black);"
                    [ngClass]="{'hidden': isCollapsed}">
                {{ item.name }}
              </span>

              <mat-icon *ngIf="!isCollapsed && item.name !== 'Quotes'" style="margin-left:auto; color: var(--dvm-sidebar-text, black);">
                {{ isMenuExpanded(item.name) ? 'expand_less' : 'expand_more' }}
              </mat-icon>
            </a>

            <!-- CHILD LIST -->
            <div *ngIf="isMenuExpanded(item.name) && !isCollapsed">
              <ng-container *ngFor="let child of item.children">

                <!-- Child without grandchildren -->
                 <a mat-list-item
                   *ngIf="!hasChildren(child)"
                   class="menuItems child-menu px-4"
                   [routerLink]="child.path"
                   [ngClass]="{'active-item': isActive(child)}"
                   [matTooltip]="child.name"
                   matTooltipPosition="right">

                  <mat-icon style="color: var(--dvm-sidebar-text, black);" class="pt-2">
                    {{ child.icon }}
                  </mat-icon>

                  <span style="padding-left:20px; font-weight:500; color: var(--dvm-sidebar-text, black);">
                    {{ child.name }}
                  </span>
                </a>

                <!-- Child with grandchildren -->
                <ng-container *ngIf="hasChildren(child)">
                  <a mat-list-item
                     class="menuItems child-menu px-4"
                     (click)="toggleSubmenu(child.name, $event)"
                     [matTooltip]="child.name"
                     matTooltipPosition="right">

                    <mat-icon style="color: var(--dvm-sidebar-text, black);" class="pt-2">
                      {{ child.icon }}
                    </mat-icon>

                    <span style="padding-left:20px; font-weight:500; color: var(--dvm-sidebar-text, black);">
                      {{ child.name }}
                    </span>

                    <mat-icon *ngIf="child.name !== 'Manage Quotes'" style="margin-left:auto; color: var(--dvm-sidebar-text, black);">
                      {{ isMenuExpanded(child.name) ? 'expand_less' : 'expand_more' }}
                    </mat-icon>
                  </a>

                  <!-- Grandchild list -->
                  <div *ngIf="isMenuExpanded(child.name)" class="grandchild-menu">
                    <a mat-list-item
                       *ngFor="let grandchild of child.children"
                       class="menuItems grandchild-menu px-4"
                       [routerLink]="grandchild.path"
                       [ngClass]="{'active-item': isActive(grandchild)}"
                       [matTooltip]="grandchild.name"
                       matTooltipPosition="right">

                      <mat-icon style="color: var(--dvm-sidebar-text, black);" class="pt-2">
                        {{ grandchild.icon }}
                      </mat-icon>

                       <span style="padding-left:40px; font-weight:500; color: var(--dvm-sidebar-text, black);">
                        {{ grandchild.name }}
                      </span>
                    </a>
                  </div>
                </ng-container>

              </ng-container>
            </div>

          </ng-container>

        </ng-container>
      </mat-nav-list>

      <!-- Sidebar bottom branding block (shown in both use cases when alt sidenav is off) -->
      <div *ngIf="!useAltSidenav"
           class="sidenav-branding-bottom"
           [class.collapsed]="isCollapsed">

        <!-- Need Help / Get Support card — shown in both Use Case 1 and Use Case 2 -->
        <div *ngIf="!isCollapsed" class="help-card">
          <div class="help-title">Need Help?</div>
          <div class="help-subtitle">Contact support for assistance</div>
          <button class="get-support-btn" (click)="goToHelp()">Get Support</button>
        </div>

        <!-- SIM Advisory logo + text — only Use Case 2 (client logo in toolbar means SIMA moves here) -->
        <div *ngIf="hasClientLogo" class="sim-branding" [class.collapsed]="isCollapsed">
          <img [src]="logo" alt="SIM Advisory" class="sim-logo">
          <span *ngIf="!isCollapsed" class="sim-text">{{ companyText }}</span>
        </div>
      </div>

      <!-- Resize handle — drag to set sidebar width. Hidden on mobile and
           when collapsed. Persists to localStorage on release. -->
      <div *ngIf="!isMobileLayout && !isCollapsed"
           class="sidebar-resize-handle"
           [class.dragging]="isResizingSidebar"
           role="separator"
           aria-label="Resize sidebar"
           aria-orientation="vertical"
           (pointerdown)="startSidebarResize($event)">
      </div>

    </mat-sidenav>

    <!-- CONTENT -->
    <mat-sidenav-content
      class="bg-gray-100 transition-all duration-300 ease-in-out overflow-auto"
      style="margin-top: calc(var(--top-toolbar-height) + var(--slideshow-strip-h, 0px)); height: calc(var(--dvh, 100vh) - var(--top-toolbar-height) - var(--slideshow-strip-h, 0px));">

      <div
        [style.margin]="isChatRoute ? '0' : '1.5rem'"
        [style.height]="isChatRoute ? '100%' : null"
        [style.min-height]="isChatRoute ? '0' : null">
        <router-outlet></router-outlet>
      </div>
    </mat-sidenav-content>

  </mat-sidenav-container>
</div>
